import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { UpdateLoanApi } from "../../ApiRequests";
import AuthBtn from "../Buttons/AuthBtn";
import { fetchLoans } from "../../store/Slices/LoanSlice";

const EditLoanModal = ({ open, setOpen, selectedLoan }) => {
  const [partyName, setPartyName] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!selectedLoan) return;
    setPartyName(selectedLoan.partyName || "");
    setPhone(selectedLoan.phone || "");
  }, [selectedLoan]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!partyName.trim()) {
      WarningToast("Enter party name");
    } else {
      try {
        const response = await UpdateLoanApi(selectedLoan._id, {
          partyName: partyName.trim(),
          phone: phone.trim(),
        });
        if (response.data.success) {
          SuccessToast("Party account updated");
          dispatch(fetchLoans());
          setOpen(false);
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        ErrorToast(err.response?.data?.error?.msg || "Update failed");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Edit party account
        </h1>
        <div className="flex flex-col gap-y-4 px-10">
          <AuthInput label="Party name" Value={partyName} setValue={setPartyName} />
          <AuthInput label="Phone" Value={phone} setValue={setPhone} />
        </div>
        <div className="flex justify-center gap-x-2 mt-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title="Update" onSubmit={onSubmit} type={1} />
              <AuthBtn title="Cancel" onSubmit={() => setOpen(false)} type={2} />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default EditLoanModal;
